import {KeyTestData} from "../types/key-tests-modal.types";

export const defaultKeyTestData: KeyTestData = {
  id: 0,
  productId: 0,
  article: '',
  noteId: 0,
  bidBefore: 0,
  bidExpected: 0,
  bidActual: null,
  positionBefore: 0,
  positionExpected: 0,
  positionActual: null,
  dailySalesBefore: null,
  dailySalesExpected: null,
  dailySalesActual: null,
  cpoBefore: null,
  cpoExpected: null,
  cpoActual: null,
  adBudgetBefore: null,
  adBudgetExpected: null,
  adBudgetActual: null,
  comment: null,
  date: null,
  time: null,
  title: null
}
